// Translations for English, French, Haitian Creole, and Spanish

const translations = {
  en: {
    // Header
    signalGenerator: "Signal Generator",
    tradingPortal: "Trading Signal Portal",
    admin: "Admin",
    loginSignup: "Login / Sign Up",
    logout: "Logout",
    welcome: "Welcome",
    
    // Navigation & Common
    home: "Home",
    dashboard: "Dashboard",
    settings: "Settings",
    profile: "Profile",
    back: "Back",
    next: "Next",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    search: "Search",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    
    // Guest Portal
    manualSignalGenerator: "Manual Signal Generator",
    selectPairDescription: "Select a trading pair and generate signal based on MACD, Stochastic & RSI indicators",
    selectTradingPair: "Select Trading Pair",
    availablePairs: "Available Pairs",
    yourSignals: "Your Signals",
    generateSignal: "Generate Signal",
    loginToGenerate: "Login to Generate Signal",
    signUpPrompt: "Sign up and get approved to access signal generation",
    generating: "Generating...",
    searchPairs: "Search pairs...",
    
    // Pro Tip
    proTip: "Pro Tip",
    proTipMessage: "Always generate signals 18 seconds before the next candle for better results",
    
    // Analyzing
    analyzingMarket: "Analyzing Market Data...",
    analyzingMarketShort: "Analyzing Market...",
    scanningBestEntry: "Scanning for the best entry point...",
    macdAnalysis: "MACD Analysis",
    rsiAnalysis: "RSI Analysis",
    stochasticAnalysis: "Stochastic",
    
    // Signal Results
    signalFound: "Signal Found!",
    noSignalFound: "No Signal Available",
    waitingForSignal: "Waiting for signal conditions to align",
    direction: "Direction",
    expiry: "Expiry",
    payout: "Payout",
    accuracy: "Accuracy",
    signalStrength: "Signal Strength",
    hotSignal: "HOT SIGNAL",
    strongSignal: "STRONG SIGNAL",
    allIndicatorsAgree: "ALL 3 INDICATORS AGREE!",
    twoIndicatorsAgree: "2 of 3 indicators agree",
    buy: "BUY",
    sell: "SELL",
    call: "CALL",
    put: "PUT",
    recommendedExpiry: "Recommended Expiry",
    
    // Trade Reporting
    reportTradeResult: "Report Your Trade Result",
    reportPrompt: "Did your last trade win or lose? Report to generate new signal",
    win: "WIN",
    loss: "LOSS",
    skip: "SKIP",
    skipIfNotTraded: "Skip if you didn't trade this signal",
    lastSignal: "Last signal",
    on: "on",
    
    // Profitability Stats
    tradingStats: "Your Trading Stats",
    trades: "Trades",
    wins: "Wins",
    losses: "Losses",
    winRate: "Win Rate",
    last24h: "Last 24h",
    yesterday: "Yesterday",
    thisWeek: "This Week",
    allTime: "All Time",
    profitability: "Profitability",
    
    // Top Assets
    topAssets: "Top Assets",
    topProfitable: "Top Profitable",
    mostStable: "Most Stable",
    viewAll: "View All",
    
    // Indicators
    selectIndicators: "Select Indicators",
    allIndicators: "All Indicators",
    indicators: "Indicators",
    
    // Auth Modal
    login: "Login",
    createAccount: "Create Account",
    emailAddress: "Email Address",
    nameOptional: "Name (optional)",
    enterEmail: "Enter your email to access signals",
    signUpForSignals: "Sign up for trading signals",
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    signUp: "Sign up",
    continue: "Continue",
    pleaseWait: "Please wait...",
    getStarted: "Get Started",
    
    // Profile Completion
    completeProfile: "Complete Your Profile",
    selectCountry: "Select your country",
    completeProfileButton: "Complete Profile",
    
    // Plan Selection
    choosePlan: "Choose Your Plan",
    freeTrial: "Essential Plan",
    free: "FROM $20",
    trialFeature1: "5 days full access",
    trialFeature2: "All trading pairs",
    trialFeature3: "Real-time signals",
    trialExpires: "Essential: $20/5-day • Premium: $59.99/month",
    startFreeTrial: "Start Now",
    monthlySubscription: "Premium Subscription",
    subscriptionFeature1: "30 days full access",
    subscriptionFeature2: "All trading pairs",
    subscriptionFeature3: "Real-time signals",
    subscriptionFeature4: "Priority support",
    subscribeNow: "Subscribe Now",
    paymentVia: "Payment via USDT (BNB Smart Chain)",
    
    // Referral System
    haveReferralCode: "Have a referral code?",
    enterCode: "Enter code",
    discountApplied: "discount applied!",
    from: "from",
    invalidCode: "Invalid code",
    referralProgram: "Referral Program",
    yourReferralCode: "Your Referral Code",
    yourReferralLink: "Your Referral Link",
    copyLink: "Copy Link",
    copied: "Copied!",
    shareWithFriends: "Share with friends and earn rewards!",
    referralBonus: "Referral Bonus",
    referredUsers: "Referred Users",
    
    // Payment Modal
    trialExpired: "Trial Expired",
    trialEndedMessage: "Your free trial has ended. Subscribe to continue.",
    getUnlimitedAccess: "Get unlimited access to trading signals",
    oneTimePayment: "One-time payment (Non-recurring)",
    scanQRCode: "Scan QR code to pay with",
    network: "Network",
    paymentInstructions: "Payment Instructions",
    instruction1: "Open your crypto wallet (Trust Wallet, MetaMask, etc.)",
    instruction2: "Select USDT on BNB Smart Chain",
    instruction3: "Scan the QR code above",
    instruction4: "Send exactly",
    instruction5: "Click \"I've Made Payment\" below",
    warning: "Only send USDT on BNB Smart Chain (BEP-20). Sending other tokens or using wrong network will result in loss of funds.",
    iveMadePayment: "I've Made Payment",
    maybeLater: "Maybe Later",
    paymentFor: "Payment for",
    paymentRequired: "Payment required to continue using the app",
    
    // Payment Proof Upload
    uploadPaymentProof: "Upload Payment Proof",
    yourName: "Your Name",
    enterYourName: "Enter your full name",
    uploadScreenshot: "Upload Screenshot",
    selectScreenshot: "Select payment screenshot",
    maxFileSize: "Max file size: 5MB (PNG, JPG, JPEG)",
    submitPaymentProof: "Submit Payment Proof",
    uploading: "Uploading...",
    paymentProofSubmitted: "Payment proof submitted! Admin will verify shortly.",
    backToPayment: "Back to Payment",
    
    // Status Messages
    pendingVerification: "Pending Email Verification",
    pendingApproval: "Pending Approval",
    accountBlocked: "Account Blocked",
    accountRejected: "Account Not Approved",
    accountApproved: "Account Approved",
    trialActive: "Trial Active",
    subscriptionActive: "Subscription Active",
    
    // Promotion
    specialOffer: "Special Offer!",
    copyCode: "Code",
    discount: "Discount",
    
    // Education TV
    educationTV: "Education TV",
    watchNow: "Watch Now",
    newContent: "New Content",
    noVideosAvailable: "No videos available",
    
    // Messenger
    messages: "Messages",
    newMessage: "New Message",
    typeMessage: "Type a message...",
    send: "Send",
    noMessages: "No messages yet",
    unreadMessages: "unread messages",
    
    // Footer
    disclaimer: "Trading signals are for educational purposes only. Always trade responsibly.",
    
    // Language
    language: "Language",
    english: "English",
    french: "French",
    haitianCreole: "Haitian Creole",
    spanish: "Spanish",
    
    // Visitor Landing Page
    welcomeTitle: "Welcome to BonBot",
    welcomeSubtitle: "Your Smart Trading Companion",
    heroDescription: "Get accurate trading signals powered by advanced technical analysis",
    feature1Title: "Real-Time Signals",
    feature1Desc: "Get instant trading signals based on MACD, RSI, and Stochastic indicators",
    feature2Title: "High Accuracy",
    feature2Desc: "Our signals have proven track record with high win rates",
    feature3Title: "Easy to Use",
    feature3Desc: "Simple interface designed for traders of all experience levels",
    startTradingNow: "Start Trading Now",
    joinThousands: "Join thousands of successful traders",
    
    // Time
    seconds: "seconds",
    minutes: "minutes",
    hours: "hours",
    days: "days",
    ago: "ago",
    justNow: "Just now",
    
    // Misc
    online: "Online",
    offline: "Offline",
    active: "Active",
    inactive: "Inactive",
    approved: "Approved",
    pending: "Pending",
    rejected: "Rejected",
    blocked: "Blocked",
    trial: "Trial",
    paid: "Paid",
    
    // Chat Bot & Messenger
    supportChat: "Support Chat",
    chatWithAdmin: "Chat with Admin",
    chatWithSupport: "Chat with Support",
    noMessagesYet: "No messages yet",
    startConversation: "Send a message to start the conversation",
    typeMessage: "Type a message...",
    loadingMessages: "Loading messages...",
    messageSent: "Message sent!",
    newMessageFromAdmin: "New message from Admin!",
    newMessageFromUser: "New message from user!",
    
    // Chat Bot Greeting
    botGreeting: "👋 Hello! Welcome to Pocket Option Pro Support!",
    botHowCanIHelp: "How can I help you today?",
    paymentHelp: "💳 Payment Help",
    referralHelp: "🎁 Referral Program",
    talkToSupport: "👤 Talk to Support",
    
    // Payment Bot Response
    paymentBotTitle: "💳 Payment Information",
    paymentBotIntro: "Here's how our payment system works:",
    paymentBotStep1: "1. Monthly subscription costs $59.99 USD",
    paymentBotStep2: "2. We accept USDT on BNB Smart Chain (BEP-20) network only",
    paymentBotStep3: "3. Scan the QR code or copy the wallet address",
    paymentBotStep4: "4. After payment, click 'I've Made Payment' and upload proof",
    paymentBotStep5: "5. Admin will verify and activate your account within 24 hours",
    paymentBotWalletLabel: "💰 Wallet Address (BEP-20):",
    paymentBotWarning: "⚠️ Only send USDT on BNB Smart Chain network!",
    
    // Referral Bot Response
    referralBotTitle: "🎁 Referral Program",
    referralBotIntro: "Earn free subscription days by referring friends!",
    referralBotStep1: "1. Share your unique referral link with friends",
    referralBotStep2: "2. When they sign up and subscribe, you get 7 FREE days",
    referralBotStep3: "3. You can earn up to 30 days of free access!",
    referralBotStep4: "4. Check your referral stats in the Refer & Earn section",
    referralBotNote: "💡 The more friends you refer, the more free days you earn!",
    
    // Talk to Support Form
    talkToSupportTitle: "👤 Talk to Support",
    enterYourNameChat: "Enter your name",
    describeIssue: "Describe your issue or question",
    submitToSupport: "Submit to Support",
    supportRequestSent: "✅ Your message has been sent to support!",
    supportWillRespond: "Our team will respond shortly.",
    
    // Read Receipts
    seen: "Seen",
    delivered: "Delivered",
    
    // Chat Controls
    endChat: "End Chat",
    chatEnded: "Chat Ended",
    chatEndedByAdmin: "This chat was ended by admin due to inactivity.",
    chatEndedByUser: "You ended this chat.",
    noResponseTimeout: "No response for 20 minutes",
    startNewConversation: "Start New Conversation",
    
    // Image Upload
    attachImage: "Attach Image",
    imageUploaded: "Image uploaded",
    imageTooLarge: "Image must be less than 5MB",
    invalidImageType: "Only PNG, JPG, JPEG images allowed",
    smartTradingSignals: "A Smart Trading System Where Education Wins",
    makeInformedDecisions: "Make informed decisions with AI-powered market analysis",
    getStartedSignIn: "Get Started - Sign In Now",
    missQuote: "You miss 100% of the shots you don't take",
    wayneGretzky: "Wayne Gretzky",
    aiPoweredSignals: "AI-Powered Signals",
    aiPoweredSignalsDesc: "MACD, Stochastic & RSI analysis combined for accurate predictions",
    trackYourSuccess: "Track Your Success",
    trackYourSuccessDesc: "Monitor win rates and profitability with detailed statistics",
    topPerformersTitle: "Top Performers",
    topPerformersDesc: "See the most profitable and stable assets in real-time",
    topPerformers: "Top Performers",
    live: "LIVE",
    signalAccuracy: "Signal Accuracy",
    tradingPairs: "Trading Pairs",
    otcMarkets: "OTC Markets",
    systemAvailability: "System Availability",
    startingFrom: "Starting From",
    freeTrialAccess: "Subscription Plans",
    
    // TradingView Indicator
    tradingViewIndicator: "TradingView Smart Indicator",
    tradingViewIndicatorDesc: "Professional-grade signals for Forex & Futures markets",
    forexMarkets: "Forex Markets",
    futuresMarkets: "Futures Markets",
    smartSignals: "Smart Signals",
    
    // Coding Service
    codingServiceTitle: "Tell Us Your Strategy & We'll Code It For You",
    codingServiceCta: "Custom indicators & trading bots",
    contactUsNow: "Contact Us Now!",
    
    // Support Ticket
    needHelp: "Need Help?",
    supportDescription: "Submit a support ticket and our team will get back to you as soon as possible.",
    ticketSubmitted: "Ticket Submitted!",
    ticketSubmittedDesc: "We've received your message and will respond to your email shortly.",
    yourName: "Your Name",
    enterYourName: "Enter your name",
    yourEmail: "Your Email",
    enterYourEmail: "Enter your email",
    subject: "Subject",
    enterSubject: "What is this about?",
    message: "Message",
    enterMessage: "Describe your issue or question...",
    submitting: "Submitting...",
    submitTicket: "Submit Ticket",
    
    // Disclaimer
    disclaimer: "Disclaimer",
    disclaimerText: "We do not provide financial, investment, or trading advice, and we do not manage or invest assets on your behalf. All content and tools provided are for educational purposes only, intended to help you better understand the markets and approach them with informed judgment.",
    checkSpamFolder: "Please check your spam or junk folder if you don't see our email.",
    
    joinTraders: "Join thousands of traders making smarter decisions",
    createFreeAccount: "Get Started",
    topProfitableAssets: "Top Profitable Assets",
    basedOnUserReports: "Based on user trade reports",
    noTradeDataYet: "No trade data yet",
    mostStableAssets: "Most Stable Assets",
    stableAssetsDesc: "Last 30 min • Low wick • Clear signals",
    analyzingAssets: "Analyzing assets...",
    stability: "Stability",
    clearSignals: "clear signals",
    allIndicatorsMacdStochRsi: "All Indicators (MACD + STOCH + RSI)",
    macdOnly: "MACD Only",
    stochasticOnly: "Stochastic Only",
    rsiPeriod7Only: "RSI (Period 7) Only",
    usingAllIndicators: "🔥 Using all 3 indicators - HOT signal when all agree!",
    macdDesc: "📊 MACD: Histogram crosses above/below 0 line",
    stochDesc: "📈 Stochastic: K line enters/exits overbought/oversold zones",
    rsiDesc: "⚡ RSI 7: Crosses above/below 50 level (Pocket Option style)",
    smartExpiryRecommendation: "Smart Expiry Recommendation",
    aiSuggestsOptimal: "AI suggests optimal trade duration",
    autoScanner: "Auto Scanner",
    autoScannerDesc: "Automatically scan multiple assets for signals",
    highPayoutFilter: "High Payout Only (92%+)",
    highPayoutFilterDesc: "Filter for assets with 92%+ payout rate",
    assetsAvailable: "high payout assets available",
    reportBeforeNew: "📊 Report your trade result before generating a new signal",
    generateSignalFor: "🎯 Generate Signal for",
    analyzingMarketSecs: "Analyzing Market...",
    generatingSignal: "Generating Signal...",
    loginToGenerateSignal: "🔒 Login to Generate Signal",
    signUpToAccess: "Sign up and get approved to access signal generation",
    hotSignalAll3: "🔥🔥🔥 HOT SIGNAL - ALL 3 INDICATORS AGREE! 🔥🔥🔥",
    executeNow: "⚡ EXECUTE NOW",
    medium: "MEDIUM",
    suggested: "SUGGESTED",
    confidence: "confidence",
    momentumScore: "Momentum Score",
    noTradesRecorded: "No trades recorded for this period",
    tradingDisclaimer1: "Trading signals are for educational purposes only.",
    tradingDisclaimer2: "Always trade responsibly.",
    referAndEarn: "Refer & Earn",
    get7FreeDays: "Get 7 free days for each friend who subscribes!",
    loadingReferralInfo: "Loading your referral info...",
    sessionExpiredInvalid: "Session expired or invalid",
    pleaseLogOutIn: "Please log out and log back in",
    retry: "Retry",
    unableLoadReferral: "Unable to load referral code",
    tokenMayChanged: "Your token may have changed. Please log out and log back in.",
    yourCode: "Your Code",
    referrals: "Referrals",
    bonusDays: "Bonus Days",
    extension: "Extension",
    howItWorks: "How it works:",
    howItWorksStep1: "1. Share your referral link with friends",
    howItWorksStep2: "2. When they sign up and subscribe, you get 7 free days",
    howItWorksStep3: "3. Earn up to 30 days of free access!",
    shareOnWhatsApp: "Share on WhatsApp",
    shareOnTelegram: "Share on Telegram",
    joinMeOnTrading: "Join me on Trading Signal Generator and get premium signals! Use my link:",
    paymentProofAwait: "Payment proof submitted! Awaiting admin verification.",
    youveBeenReferred: "You've been referred! Sign up now to get started.",
    signUpNow: "Sign Up Now",
    foundPairs: "Found",
    pairs: "pairs",
    noPairsFound: "No pairs found for",
    trySearchTerms: "Try: EUR, USD, BTC, GOLD",
    forex: "FOREX",
    crypto: "CRYPTO",
    commodities: "COMMODITIES",
    stocks: "STOCKS"
  },
  
  es: {
    // Header
    signalGenerator: "Generador de Señales",
    tradingPortal: "Portal de Señales de Trading",
    admin: "Admin",
    loginSignup: "Iniciar Sesión / Registrarse",
    logout: "Cerrar Sesión",
    welcome: "Bienvenido",
    
    // Navigation & Common
    home: "Inicio",
    dashboard: "Panel",
    settings: "Configuración",
    profile: "Perfil",
    back: "Atrás",
    next: "Siguiente",
    save: "Guardar",
    cancel: "Cancelar",
    close: "Cerrar",
    confirm: "Confirmar",
    delete: "Eliminar",
    edit: "Editar",
    search: "Buscar",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    
    // Guest Portal
    manualSignalGenerator: "Generador de Señales Manual",
    selectPairDescription: "Selecciona un par de trading y genera señales basadas en indicadores MACD, Estocástico y RSI",
    selectTradingPair: "Seleccionar Par de Trading",
    availablePairs: "Pares Disponibles",
    yourSignals: "Tus Señales",
    generateSignal: "Generar Señal",
    loginToGenerate: "Inicia Sesión para Generar Señal",
    signUpPrompt: "Regístrate y obtén aprobación para acceder a la generación de señales",
    generating: "Generando...",
    searchPairs: "Buscar pares...",
    
    // Pro Tip
    proTip: "Consejo Pro",
    proTipMessage: "Siempre genera señales 18 segundos antes de la próxima vela para mejores resultados",
    
    // Analyzing
    analyzingMarket: "Analizando Datos del Mercado...",
    analyzingMarketShort: "Analizando Mercado...",
    scanningBestEntry: "Buscando el mejor punto de entrada...",
    macdAnalysis: "Análisis MACD",
    rsiAnalysis: "Análisis RSI",
    stochasticAnalysis: "Estocástico",
    
    // Signal Results
    signalFound: "¡Señal Encontrada!",
    noSignalFound: "Señal No Disponible",
    waitingForSignal: "Esperando que las condiciones de la señal se alineen",
    direction: "Dirección",
    expiry: "Expiración",
    payout: "Pago",
    accuracy: "Precisión",
    signalStrength: "Fuerza de la Señal",
    hotSignal: "SEÑAL CALIENTE",
    strongSignal: "SEÑAL FUERTE",
    allIndicatorsAgree: "¡LOS 3 INDICADORES COINCIDEN!",
    twoIndicatorsAgree: "2 de 3 indicadores coinciden",
    buy: "COMPRAR",
    sell: "VENDER",
    call: "CALL",
    put: "PUT",
    recommendedExpiry: "Expiración Recomendada",
    
    // Trade Reporting
    reportTradeResult: "Reporta el Resultado de tu Operación",
    reportPrompt: "¿Tu última operación ganó o perdió? Reporta para generar nueva señal",
    win: "GANÓ",
    loss: "PERDIÓ",
    skip: "SALTAR",
    skipIfNotTraded: "Salta si no operaste esta señal",
    lastSignal: "Última señal",
    on: "en",
    
    // Profitability Stats
    tradingStats: "Tus Estadísticas de Trading",
    trades: "Operaciones",
    wins: "Ganancias",
    losses: "Pérdidas",
    winRate: "Tasa de Éxito",
    last24h: "Últimas 24h",
    yesterday: "Ayer",
    thisWeek: "Esta Semana",
    allTime: "Todo el Tiempo",
    profitability: "Rentabilidad",
    
    // Top Assets
    topAssets: "Mejores Activos",
    topProfitable: "Más Rentables",
    mostStable: "Más Estables",
    viewAll: "Ver Todo",
    
    // Indicators
    selectIndicators: "Seleccionar Indicadores",
    allIndicators: "Todos los Indicadores",
    indicators: "Indicadores",
    
    // Auth Modal
    login: "Iniciar Sesión",
    createAccount: "Crear Cuenta",
    emailAddress: "Correo Electrónico",
    nameOptional: "Nombre (opcional)",
    enterEmail: "Ingresa tu correo para acceder a las señales",
    signUpForSignals: "Regístrate para señales de trading",
    dontHaveAccount: "¿No tienes cuenta?",
    alreadyHaveAccount: "¿Ya tienes cuenta?",
    signUp: "Registrarse",
    continue: "Continuar",
    pleaseWait: "Por favor espera...",
    getStarted: "Comenzar",
    
    // Profile Completion
    completeProfile: "Completa tu Perfil",
    selectCountry: "Selecciona tu país",
    completeProfileButton: "Completar Perfil",
    
    // Plan Selection
    choosePlan: "Elige tu Plan",
    freeTrial: "Plan Esencial",
    free: "DESDE $20",
    trialFeature1: "5 días de acceso completo",
    trialFeature2: "Todos los pares de trading",
    trialFeature3: "Señales en tiempo real",
    trialExpires: "Esencial: $20/5 días • Premium: $59.99/mes",
    startFreeTrial: "Comenzar Ahora",
    monthlySubscription: "Suscripción Premium",
    subscriptionFeature1: "30 días de acceso completo",
    subscriptionFeature2: "Todos los pares de trading",
    subscriptionFeature3: "Señales en tiempo real",
    subscriptionFeature4: "Soporte prioritario",
    subscribeNow: "Suscribirse Ahora",
    paymentVia: "Pago mediante USDT (BNB Smart Chain)",
    
    // Referral System
    haveReferralCode: "¿Tienes un código de referido?",
    enterCode: "Ingresa el código",
    discountApplied: "¡descuento aplicado!",
    from: "de",
    invalidCode: "Código inválido",
    referralProgram: "Programa de Referidos",
    yourReferralCode: "Tu Código de Referido",
    yourReferralLink: "Tu Enlace de Referido",
    copyLink: "Copiar Enlace",
    copied: "¡Copiado!",
    shareWithFriends: "¡Comparte con amigos y gana recompensas!",
    referralBonus: "Bono de Referido",
    referredUsers: "Usuarios Referidos",
    
    // Payment Modal
    trialExpired: "Prueba Expirada",
    trialEndedMessage: "Tu prueba gratis ha terminado. Suscríbete para continuar.",
    getUnlimitedAccess: "Obtén acceso ilimitado a señales de trading",
    oneTimePayment: "Pago único (No recurrente)",
    scanQRCode: "Escanea el código QR para pagar con",
    network: "Red",
    paymentInstructions: "Instrucciones de Pago",
    instruction1: "Abre tu billetera cripto (Trust Wallet, MetaMask, etc.)",
    instruction2: "Selecciona USDT en BNB Smart Chain",
    instruction3: "Escanea el código QR de arriba",
    instruction4: "Envía exactamente",
    instruction5: "Haz clic en \"Ya Hice el Pago\" abajo",
    warning: "Solo envía USDT en BNB Smart Chain (BEP-20). Enviar otros tokens o usar la red incorrecta resultará en pérdida de fondos.",
    iveMadePayment: "Ya Hice el Pago",
    maybeLater: "Quizás Después",
    paymentFor: "Pago por",
    paymentRequired: "Pago requerido para continuar usando la app",
    
    // Payment Proof Upload
    uploadPaymentProof: "Subir Comprobante de Pago",
    yourName: "Tu Nombre",
    enterYourName: "Ingresa tu nombre completo",
    uploadScreenshot: "Subir Captura de Pantalla",
    selectScreenshot: "Seleccionar captura del pago",
    maxFileSize: "Tamaño máximo: 5MB (PNG, JPG, JPEG)",
    submitPaymentProof: "Enviar Comprobante de Pago",
    uploading: "Subiendo...",
    paymentProofSubmitted: "¡Comprobante enviado! El admin verificará pronto.",
    backToPayment: "Volver al Pago",
    
    // Status Messages
    pendingVerification: "Verificación de Email Pendiente",
    pendingApproval: "Aprobación Pendiente",
    accountBlocked: "Cuenta Bloqueada",
    accountRejected: "Cuenta No Aprobada",
    accountApproved: "Cuenta Aprobada",
    trialActive: "Prueba Activa",
    subscriptionActive: "Suscripción Activa",
    
    // Promotion
    specialOffer: "¡Oferta Especial!",
    copyCode: "Código",
    discount: "Descuento",
    
    // Education TV
    educationTV: "TV Educativa",
    watchNow: "Ver Ahora",
    newContent: "Nuevo Contenido",
    noVideosAvailable: "No hay videos disponibles",
    
    // Messenger
    messages: "Mensajes",
    newMessage: "Nuevo Mensaje",
    typeMessage: "Escribe un mensaje...",
    send: "Enviar",
    noMessages: "Sin mensajes aún",
    unreadMessages: "mensajes sin leer",
    
    // Footer
    disclaimer: "Las señales de trading son solo para fines educativos. Opera siempre con responsabilidad.",
    
    // Language
    language: "Idioma",
    english: "Inglés",
    french: "Francés",
    haitianCreole: "Criollo Haitiano",
    spanish: "Español",
    
    // Visitor Landing Page
    welcomeTitle: "Bienvenido a BonBot",
    welcomeSubtitle: "Tu Compañero Inteligente de Trading",
    heroDescription: "Obtén señales de trading precisas impulsadas por análisis técnico avanzado",
    feature1Title: "Señales en Tiempo Real",
    feature1Desc: "Obtén señales instantáneas basadas en indicadores MACD, RSI y Estocástico",
    feature2Title: "Alta Precisión",
    feature2Desc: "Nuestras señales tienen un historial comprobado con altas tasas de éxito",
    feature3Title: "Fácil de Usar",
    feature3Desc: "Interfaz simple diseñada para traders de todos los niveles",
    startTradingNow: "Comienza a Operar Ahora",
    joinThousands: "Únete a miles de traders exitosos",
    
    // Time
    seconds: "segundos",
    minutes: "minutos",
    hours: "horas",
    days: "días",
    ago: "hace",
    justNow: "Ahora mismo",
    
    // Misc
    online: "En línea",
    offline: "Desconectado",
    active: "Activo",
    inactive: "Inactivo",
    approved: "Aprobado",
    pending: "Pendiente",
    rejected: "Rechazado",
    blocked: "Bloqueado",
    trial: "Prueba",
    paid: "Pagado",
    
    // Chat Bot & Messenger
    supportChat: "Chat de Soporte",
    chatWithAdmin: "Chat con Admin",
    chatWithSupport: "Chat con Soporte",
    noMessagesYet: "Sin mensajes aún",
    startConversation: "Envía un mensaje para iniciar la conversación",
    typeMessage: "Escribe un mensaje...",
    loadingMessages: "Cargando mensajes...",
    messageSent: "¡Mensaje enviado!",
    newMessageFromAdmin: "¡Nuevo mensaje del Admin!",
    newMessageFromUser: "¡Nuevo mensaje del usuario!",
    
    // Chat Bot Greeting
    botGreeting: "👋 ¡Hola! ¡Bienvenido al Soporte de Pocket Option Pro!",
    botHowCanIHelp: "¿Cómo puedo ayudarte hoy?",
    paymentHelp: "💳 Ayuda con Pago",
    referralHelp: "🎁 Programa de Referidos",
    talkToSupport: "👤 Hablar con Soporte",
    
    // Payment Bot Response
    paymentBotTitle: "💳 Información de Pago",
    paymentBotIntro: "Así funciona nuestro sistema de pago:",
    paymentBotStep1: "1. La suscripción mensual cuesta $59.99 USD",
    paymentBotStep2: "2. Aceptamos USDT en la red BNB Smart Chain (BEP-20) únicamente",
    paymentBotStep3: "3. Escanea el código QR o copia la dirección de la billetera",
    paymentBotStep4: "4. Después del pago, haz clic en 'Ya Hice el Pago' y sube el comprobante",
    paymentBotStep5: "5. El admin verificará y activará tu cuenta en 24 horas",
    paymentBotWalletLabel: "💰 Dirección de Billetera (BEP-20):",
    paymentBotWarning: "⚠️ ¡Solo envía USDT en la red BNB Smart Chain!",
    
    // Referral Bot Response
    referralBotTitle: "🎁 Programa de Referidos",
    referralBotIntro: "¡Gana días de suscripción gratis refiriendo amigos!",
    referralBotStep1: "1. Comparte tu enlace de referido único con amigos",
    referralBotStep2: "2. Cuando se registren y suscriban, obtienes 7 días GRATIS",
    referralBotStep3: "3. ¡Puedes ganar hasta 30 días de acceso gratis!",
    referralBotStep4: "4. Revisa tus estadísticas en la sección Referir y Ganar",
    referralBotNote: "💡 ¡Cuantos más amigos refieras, más días gratis ganas!",
    
    // Talk to Support Form
    talkToSupportTitle: "👤 Hablar con Soporte",
    enterYourNameChat: "Ingresa tu nombre",
    describeIssue: "Describe tu problema o pregunta",
    submitToSupport: "Enviar a Soporte",
    supportRequestSent: "✅ ¡Tu mensaje ha sido enviado a soporte!",
    supportWillRespond: "Nuestro equipo responderá pronto.",
    
    // Read Receipts
    seen: "Visto",
    delivered: "Entregado",
    
    // Chat Controls
    endChat: "Terminar Chat",
    chatEnded: "Chat Terminado",
    chatEndedByAdmin: "Este chat fue terminado por el admin debido a inactividad.",
    chatEndedByUser: "Has terminado este chat.",
    noResponseTimeout: "Sin respuesta por 20 minutos",
    startNewConversation: "Iniciar Nueva Conversación",
    
    // Image Upload
    attachImage: "Adjuntar Imagen",
    imageUploaded: "Imagen subida",
    imageTooLarge: "La imagen debe ser menor a 5MB",
    invalidImageType: "Solo se permiten imágenes PNG, JPG, JPEG",
    
    // Additional Guest Portal Keys
    smartTradingSignals: "Un Sistema de Trading Inteligente Donde la Educación Gana",
    makeInformedDecisions: "Toma decisiones informadas con análisis de mercado impulsado por IA",
    getStartedSignIn: "Comenzar - Iniciar Sesión",
    missQuote: "Pierdes el 100% de los tiros que no haces",
    wayneGretzky: "Wayne Gretzky",
    aiPoweredSignals: "Señales con IA",
    aiPoweredSignalsDesc: "Análisis MACD, Estocástico y RSI combinados para predicciones precisas",
    trackYourSuccess: "Rastrea tu Éxito",
    trackYourSuccessDesc: "Monitorea tasas de éxito y rentabilidad con estadísticas detalladas",
    topPerformersTitle: "Mejores Rendimientos",
    topPerformersDesc: "Ve los activos más rentables y estables en tiempo real",
    topPerformers: "Top Performers",
    live: "EN VIVO",
    signalAccuracy: "Precisión de Señales",
    tradingPairs: "Pares de Trading",
    otcMarkets: "Mercados OTC",
    systemAvailability: "Disponibilidad del Sistema",
    startingFrom: "Desde",
    freeTrialAccess: "Planes de Suscripción",
    
    // TradingView Indicator
    tradingViewIndicator: "Indicador Inteligente TradingView",
    tradingViewIndicatorDesc: "Señales de nivel profesional para mercados de Forex y Futuros",
    forexMarkets: "Mercados Forex",
    futuresMarkets: "Mercados de Futuros",
    smartSignals: "Señales Inteligentes",
    
    // Coding Service
    codingServiceTitle: "Cuéntanos Tu Estrategia y La Programamos Para Ti",
    codingServiceCta: "Indicadores personalizados y bots de trading",
    contactUsNow: "¡Contáctanos Ahora!",
    
    // Support Ticket
    needHelp: "¿Necesitas Ayuda?",
    supportDescription: "Envía un ticket de soporte y nuestro equipo te responderá lo antes posible.",
    ticketSubmitted: "¡Ticket Enviado!",
    ticketSubmittedDesc: "Hemos recibido tu mensaje y responderemos a tu correo pronto.",
    yourName: "Tu Nombre",
    enterYourName: "Ingresa tu nombre",
    yourEmail: "Tu Email",
    enterYourEmail: "Ingresa tu email",
    subject: "Asunto",
    enterSubject: "¿De qué se trata?",
    message: "Mensaje",
    enterMessage: "Describe tu problema o pregunta...",
    submitting: "Enviando...",
    submitTicket: "Enviar Ticket",
    
    // Disclaimer
    disclaimer: "Descargo de Responsabilidad",
    disclaimerText: "No proporcionamos asesoría financiera, de inversión ni de trading, y no gestionamos ni invertimos activos en tu nombre. Todo el contenido y herramientas se proporcionan únicamente con fines educativos, destinados a ayudarte a comprender mejor los mercados y abordarlos con criterio informado.",
    checkSpamFolder: "Por favor revisa tu carpeta de spam o correo no deseado si no ves nuestro email.",
    
    joinTraders: "Únete a miles de traders que toman mejores decisiones",
    createFreeAccount: "Comenzar",
    topProfitableAssets: "Activos Más Rentables",
    basedOnUserReports: "Basado en reportes de usuarios",
    noTradeDataYet: "Sin datos de operaciones aún",
    mostStableAssets: "Activos Más Estables",
    stableAssetsDesc: "Últimos 30 min • Mecha baja • Señales claras",
    analyzingAssets: "Analizando activos...",
    stability: "Estabilidad",
    clearSignals: "señales claras",
    allIndicatorsMacdStochRsi: "Todos los Indicadores (MACD + STOCH + RSI)",
    macdOnly: "Solo MACD",
    stochasticOnly: "Solo Estocástico",
    rsiPeriod7Only: "Solo RSI (Período 7)",
    usingAllIndicators: "🔥 Usando los 3 indicadores - ¡Señal CALIENTE cuando coinciden!",
    macdDesc: "📊 MACD: Histograma cruza arriba/abajo de la línea 0",
    stochDesc: "📈 Estocástico: Línea K entra/sale de zonas de sobrecompra/sobreventa",
    rsiDesc: "⚡ RSI 7: Cruza arriba/abajo del nivel 50 (estilo Pocket Option)",
    smartExpiryRecommendation: "Recomendación de Expiración Inteligente",
    aiSuggestsOptimal: "La IA sugiere duración óptima de operación",
    reportBeforeNew: "📊 Reporta el resultado de tu operación antes de generar una nueva señal",
    generateSignalFor: "🎯 Generar Señal para",
    analyzingMarketSecs: "Analizando Mercado...",
    generatingSignal: "Generando Señal...",
    loginToGenerateSignal: "🔒 Inicia Sesión para Generar Señal",
    signUpToAccess: "Regístrate y obtén aprobación para acceder a la generación de señales",
    hotSignalAll3: "🔥🔥🔥 SEÑAL CALIENTE - ¡LOS 3 INDICADORES COINCIDEN! 🔥🔥🔥",
    executeNow: "⚡ EJECUTAR AHORA",
    medium: "MEDIO",
    suggested: "SUGERIDO",
    confidence: "confianza",
    momentumScore: "Puntuación de Impulso",
    noTradesRecorded: "No hay operaciones registradas para este período",
    tradingDisclaimer1: "Las señales de trading son solo para fines educativos.",
    tradingDisclaimer2: "Opera siempre con responsabilidad.",
    referAndEarn: "Referir y Ganar",
    get7FreeDays: "¡Obtén 7 días gratis por cada amigo que se suscriba!",
    loadingReferralInfo: "Cargando tu información de referido...",
    sessionExpiredInvalid: "Sesión expirada o inválida",
    pleaseLogOutIn: "Por favor cierra sesión e inicia de nuevo",
    retry: "Reintentar",
    unableLoadReferral: "No se puede cargar el código de referido",
    tokenMayChanged: "Tu token puede haber cambiado. Por favor cierra sesión e inicia de nuevo.",
    yourCode: "Tu Código",
    referrals: "Referidos",
    bonusDays: "Días Bonus",
    extension: "Extensión",
    howItWorks: "Cómo funciona:",
    howItWorksStep1: "1. Comparte tu enlace de referido con amigos",
    howItWorksStep2: "2. Cuando se registren y suscriban, obtienes 7 días gratis",
    howItWorksStep3: "3. ¡Gana hasta 30 días de acceso gratis!",
    shareOnWhatsApp: "Compartir en WhatsApp",
    shareOnTelegram: "Compartir en Telegram",
    joinMeOnTrading: "¡Únete a Trading Signal Generator y obtén señales premium! Usa mi enlace:",
    paymentProofAwait: "¡Comprobante enviado! Esperando verificación del admin.",
    youveBeenReferred: "¡Has sido referido! Regístrate ahora para comenzar.",
    signUpNow: "Regístrate Ahora",
    foundPairs: "Encontrados",
    pairs: "pares",
    noPairsFound: "No se encontraron pares para",
    trySearchTerms: "Prueba: EUR, USD, BTC, GOLD",
    forex: "FOREX",
    crypto: "CRIPTO",
    commodities: "MATERIAS PRIMAS",
    stocks: "ACCIONES"
  },
  
  fr: {
    // Header
    signalGenerator: "Générateur de Signaux",
    tradingPortal: "Portail de Signaux de Trading",
    admin: "Admin",
    loginSignup: "Connexion / Inscription",
    logout: "Déconnexion",
    welcome: "Bienvenue",
    
    // Navigation & Common
    home: "Accueil",
    dashboard: "Tableau de Bord",
    settings: "Paramètres",
    profile: "Profil",
    back: "Retour",
    next: "Suivant",
    save: "Enregistrer",
    cancel: "Annuler",
    close: "Fermer",
    confirm: "Confirmer",
    delete: "Supprimer",
    edit: "Modifier",
    search: "Rechercher",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    
    // Guest Portal
    manualSignalGenerator: "Générateur de Signaux Manuel",
    selectPairDescription: "Sélectionnez une paire de trading et générez un signal basé sur les indicateurs MACD, Stochastique & RSI",
    selectTradingPair: "Sélectionner une Paire de Trading",
    availablePairs: "Paires Disponibles",
    yourSignals: "Vos Signaux",
    generateSignal: "Générer un Signal",
    loginToGenerate: "Connectez-vous pour Générer un Signal",
    signUpPrompt: "Inscrivez-vous et obtenez l'approbation pour accéder à la génération de signaux",
    generating: "Génération...",
    searchPairs: "Rechercher des paires...",
    
    // Pro Tip
    proTip: "Conseil Pro",
    proTipMessage: "Générez toujours les signaux 18 secondes avant la prochaine bougie pour de meilleurs résultats",
    
    // Analyzing
    analyzingMarket: "Analyse des Données du Marché...",
    analyzingMarketShort: "Analyse du Marché...",
    scanningBestEntry: "Recherche du meilleur point d'entrée...",
    macdAnalysis: "Analyse MACD",
    rsiAnalysis: "Analyse RSI",
    stochasticAnalysis: "Stochastique",
    
    // Signal Results
    signalFound: "Signal Trouvé!",
    noSignalFound: "Aucun Signal Disponible",
    waitingForSignal: "En attente que les conditions du signal s'alignent",
    direction: "Direction",
    expiry: "Expiration",
    payout: "Paiement",
    accuracy: "Précision",
    signalStrength: "Force du Signal",
    hotSignal: "SIGNAL CHAUD",
    strongSignal: "SIGNAL FORT",
    allIndicatorsAgree: "LES 3 INDICATEURS S'ACCORDENT!",
    twoIndicatorsAgree: "2 indicateurs sur 3 s'accordent",
    buy: "ACHETER",
    sell: "VENDRE",
    call: "CALL",
    put: "PUT",
    recommendedExpiry: "Expiration Recommandée",
    
    // Trade Reporting
    reportTradeResult: "Rapportez le Résultat de Votre Trade",
    reportPrompt: "Votre dernier trade a-t-il gagné ou perdu? Rapportez pour générer un nouveau signal",
    win: "GAGNÉ",
    loss: "PERDU",
    skip: "PASSER",
    skipIfNotTraded: "Passez si vous n'avez pas tradé ce signal",
    lastSignal: "Dernier signal",
    on: "sur",
    
    // Profitability Stats
    tradingStats: "Vos Statistiques de Trading",
    trades: "Trades",
    wins: "Gains",
    losses: "Pertes",
    winRate: "Taux de Réussite",
    last24h: "Dernières 24h",
    yesterday: "Hier",
    thisWeek: "Cette Semaine",
    allTime: "Tout le Temps",
    profitability: "Rentabilité",
    
    // Top Assets
    topAssets: "Meilleurs Actifs",
    topProfitable: "Plus Rentables",
    mostStable: "Plus Stables",
    viewAll: "Voir Tout",
    
    // Indicators
    selectIndicators: "Sélectionner les Indicateurs",
    allIndicators: "Tous les Indicateurs",
    indicators: "Indicateurs",
    
    // Auth Modal
    login: "Connexion",
    createAccount: "Créer un Compte",
    emailAddress: "Adresse Email",
    nameOptional: "Nom (optionnel)",
    enterEmail: "Entrez votre email pour accéder aux signaux",
    signUpForSignals: "Inscrivez-vous pour les signaux de trading",
    dontHaveAccount: "Vous n'avez pas de compte?",
    alreadyHaveAccount: "Vous avez déjà un compte?",
    signUp: "S'inscrire",
    continue: "Continuer",
    pleaseWait: "Veuillez patienter...",
    getStarted: "Commencer",
    
    // Profile Completion
    completeProfile: "Complétez Votre Profil",
    selectCountry: "Sélectionnez votre pays",
    completeProfileButton: "Compléter le Profil",
    
    // Plan Selection
    choosePlan: "Choisissez Votre Plan",
    freeTrial: "Plan Essentiel",
    free: "À PARTIR DE $20",
    trialFeature1: "5 jours d'accès complet",
    trialFeature2: "Toutes les paires de trading",
    trialFeature3: "Signaux en temps réel",
    trialExpires: "Essentiel: $20/5 jours • Premium: $59.99/mois",
    startFreeTrial: "Commencer Maintenant",
    monthlySubscription: "Abonnement Premium",
    subscriptionFeature1: "30 jours d'accès complet",
    subscriptionFeature2: "Toutes les paires de trading",
    subscriptionFeature3: "Signaux en temps réel",
    subscriptionFeature4: "Support prioritaire",
    subscribeNow: "S'abonner Maintenant",
    paymentVia: "Paiement via USDT (BNB Smart Chain)",
    
    // Referral System
    haveReferralCode: "Avez-vous un code de parrainage?",
    enterCode: "Entrer le code",
    discountApplied: "réduction appliquée!",
    from: "de",
    invalidCode: "Code invalide",
    referralProgram: "Programme de Parrainage",
    yourReferralCode: "Votre Code de Parrainage",
    yourReferralLink: "Votre Lien de Parrainage",
    copyLink: "Copier le Lien",
    copied: "Copié!",
    shareWithFriends: "Partagez avec vos amis et gagnez des récompenses!",
    referralBonus: "Bonus de Parrainage",
    referredUsers: "Utilisateurs Parrainés",
    
    // Payment Modal
    trialExpired: "Essai Expiré",
    trialEndedMessage: "Votre essai gratuit est terminé. Abonnez-vous pour continuer.",
    getUnlimitedAccess: "Obtenez un accès illimité aux signaux de trading",
    oneTimePayment: "Paiement unique (Non récurrent)",
    scanQRCode: "Scannez le code QR pour payer avec",
    network: "Réseau",
    paymentInstructions: "Instructions de Paiement",
    instruction1: "Ouvrez votre portefeuille crypto (Trust Wallet, MetaMask, etc.)",
    instruction2: "Sélectionnez USDT sur BNB Smart Chain",
    instruction3: "Scannez le code QR ci-dessus",
    instruction4: "Envoyez exactement",
    instruction5: "Cliquez sur \"J'ai Fait le Paiement\" ci-dessous",
    warning: "Envoyez uniquement USDT sur BNB Smart Chain (BEP-20). L'envoi d'autres tokens ou l'utilisation d'un mauvais réseau entraînera une perte de fonds.",
    iveMadePayment: "J'ai Fait le Paiement",
    maybeLater: "Peut-être Plus Tard",
    paymentFor: "Paiement pour",
    paymentRequired: "Paiement requis pour continuer à utiliser l'app",
    
    // Payment Proof Upload
    uploadPaymentProof: "Télécharger la Preuve de Paiement",
    yourName: "Votre Nom",
    enterYourName: "Entrez votre nom complet",
    uploadScreenshot: "Télécharger la Capture d'Écran",
    selectScreenshot: "Sélectionner la capture d'écran du paiement",
    maxFileSize: "Taille max: 5Mo (PNG, JPG, JPEG)",
    submitPaymentProof: "Soumettre la Preuve de Paiement",
    uploading: "Téléchargement...",
    paymentProofSubmitted: "Preuve de paiement soumise! L'admin vérifiera bientôt.",
    backToPayment: "Retour au Paiement",
    
    // Status Messages
    pendingVerification: "Vérification Email en Attente",
    pendingApproval: "Approbation en Attente",
    accountBlocked: "Compte Bloqué",
    accountRejected: "Compte Non Approuvé",
    accountApproved: "Compte Approuvé",
    trialActive: "Essai Actif",
    subscriptionActive: "Abonnement Actif",
    
    // Promotion
    specialOffer: "Offre Spéciale!",
    copyCode: "Code",
    discount: "Réduction",
    
    // Education TV
    educationTV: "TV Éducative",
    watchNow: "Regarder Maintenant",
    newContent: "Nouveau Contenu",
    noVideosAvailable: "Aucune vidéo disponible",
    
    // Messenger
    messages: "Messages",
    newMessage: "Nouveau Message",
    typeMessage: "Tapez un message...",
    send: "Envoyer",
    noMessages: "Pas encore de messages",
    unreadMessages: "messages non lus",
    
    // Footer
    disclaimer: "Les signaux de trading sont à des fins éducatives uniquement. Tradez toujours de manière responsable.",
    
    // Language
    language: "Langue",
    english: "Anglais",
    french: "Français",
    haitianCreole: "Créole Haïtien",
    spanish: "Espagnol",
    
    // Visitor Landing Page
    welcomeTitle: "Bienvenue sur BonBot",
    welcomeSubtitle: "Votre Compagnon de Trading Intelligent",
    heroDescription: "Obtenez des signaux de trading précis alimentés par une analyse technique avancée",
    feature1Title: "Signaux en Temps Réel",
    feature1Desc: "Obtenez des signaux instantanés basés sur les indicateurs MACD, RSI et Stochastique",
    feature2Title: "Haute Précision",
    feature2Desc: "Nos signaux ont un historique prouvé avec des taux de réussite élevés",
    feature3Title: "Facile à Utiliser",
    feature3Desc: "Interface simple conçue pour les traders de tous niveaux",
    startTradingNow: "Commencer à Trader Maintenant",
    joinThousands: "Rejoignez des milliers de traders à succès",
    
    // Time
    seconds: "secondes",
    minutes: "minutes",
    hours: "heures",
    days: "jours",
    ago: "il y a",
    justNow: "À l'instant",
    
    // Misc
    online: "En ligne",
    offline: "Hors ligne",
    active: "Actif",
    inactive: "Inactif",
    approved: "Approuvé",
    pending: "En attente",
    rejected: "Rejeté",
    blocked: "Bloqué",
    trial: "Essai",
    paid: "Payé",
    
    // Chat Bot & Messenger
    supportChat: "Chat Support",
    chatWithAdmin: "Chat avec Admin",
    chatWithSupport: "Chat avec Support",
    noMessagesYet: "Pas encore de messages",
    startConversation: "Envoyez un message pour démarrer la conversation",
    loadingMessages: "Chargement des messages...",
    messageSent: "Message envoyé!",
    newMessageFromAdmin: "Nouveau message de l'Admin!",
    newMessageFromUser: "Nouveau message de l'utilisateur!",
    
    // Chat Bot Greeting
    botGreeting: "👋 Bonjour! Bienvenue au Support Pocket Option Pro!",
    botHowCanIHelp: "Comment puis-je vous aider aujourd'hui?",
    paymentHelp: "💳 Aide au Paiement",
    referralHelp: "🎁 Programme de Parrainage",
    talkToSupport: "👤 Parler au Support",
    
    // Payment Bot Response
    paymentBotTitle: "💳 Informations de Paiement",
    paymentBotIntro: "Voici comment fonctionne notre système de paiement:",
    paymentBotStep1: "1. L'abonnement mensuel coûte 59,99$ USD",
    paymentBotStep2: "2. Nous acceptons uniquement USDT sur le réseau BNB Smart Chain (BEP-20)",
    paymentBotStep3: "3. Scannez le code QR ou copiez l'adresse du portefeuille",
    paymentBotStep4: "4. Après le paiement, cliquez sur 'J'ai Effectué le Paiement' et téléchargez la preuve",
    paymentBotStep5: "5. L'admin vérifiera et activera votre compte sous 24 heures",
    paymentBotWalletLabel: "💰 Adresse du Portefeuille (BEP-20):",
    paymentBotWarning: "⚠️ Envoyez uniquement USDT sur le réseau BNB Smart Chain!",
    
    // Referral Bot Response
    referralBotTitle: "🎁 Programme de Parrainage",
    referralBotIntro: "Gagnez des jours d'abonnement gratuits en parrainant des amis!",
    referralBotStep1: "1. Partagez votre lien de parrainage unique avec vos amis",
    referralBotStep2: "2. Quand ils s'inscrivent et s'abonnent, vous obtenez 7 jours GRATUITS",
    referralBotStep3: "3. Vous pouvez gagner jusqu'à 30 jours d'accès gratuit!",
    referralBotStep4: "4. Consultez vos statistiques dans la section Parrainer et Gagner",
    referralBotNote: "💡 Plus vous parrainez d'amis, plus vous gagnez de jours gratuits!",
    
    // Talk to Support Form
    talkToSupportTitle: "👤 Parler au Support",
    enterYourNameChat: "Entrez votre nom",
    describeIssue: "Décrivez votre problème ou question",
    submitToSupport: "Envoyer au Support",
    supportRequestSent: "✅ Votre message a été envoyé au support!",
    supportWillRespond: "Notre équipe répondra bientôt.",
    
    // Read Receipts
    seen: "Vu",
    delivered: "Livré",
    
    // Chat Controls
    endChat: "Terminer le Chat",
    chatEnded: "Chat Terminé",
    chatEndedByAdmin: "Ce chat a été terminé par l'admin pour inactivité.",
    chatEndedByUser: "Vous avez terminé ce chat.",
    noResponseTimeout: "Pas de réponse depuis 20 minutes",
    startNewConversation: "Démarrer Nouvelle Conversation",
    
    // Image Upload
    attachImage: "Joindre une Image",
    imageUploaded: "Image téléchargée",
    imageTooLarge: "L'image doit être inférieure à 5MB",
    invalidImageType: "Seules les images PNG, JPG, JPEG sont autorisées",
    
    // Additional Guest Portal Keys
    smartTradingSignals: "Un Système de Trading Intelligent Où l'Éducation Gagne",
    makeInformedDecisions: "Prenez des décisions éclairées avec l'analyse de marché propulsée par l'IA",
    getStartedSignIn: "Commencer - Se Connecter",
    missQuote: "Vous manquez 100% des tirs que vous ne prenez pas",
    wayneGretzky: "Wayne Gretzky",
    aiPoweredSignals: "Signaux IA",
    aiPoweredSignalsDesc: "Analyse MACD, Stochastique et RSI combinées pour des prédictions précises",
    trackYourSuccess: "Suivez Votre Succès",
    trackYourSuccessDesc: "Surveillez les taux de réussite et la rentabilité avec des statistiques détaillées",
    topPerformersTitle: "Meilleurs Performants",
    topPerformersDesc: "Voyez les actifs les plus rentables et stables en temps réel",
    topPerformers: "Top Performers",
    live: "EN DIRECT",
    signalAccuracy: "Précision des Signaux",
    tradingPairs: "Paires de Trading",
    otcMarkets: "Marchés OTC",
    systemAvailability: "Disponibilité du Système",
    startingFrom: "À partir de",
    freeTrialAccess: "Plans d'Abonnement",
    
    // TradingView Indicator
    tradingViewIndicator: "Indicateur Intelligent TradingView",
    tradingViewIndicatorDesc: "Signaux de niveau professionnel pour les marchés Forex et Futures",
    forexMarkets: "Marchés Forex",
    futuresMarkets: "Marchés Futures",
    smartSignals: "Signaux Intelligents",
    
    // Coding Service
    codingServiceTitle: "Dites-Nous Votre Stratégie et Nous La Coderons Pour Vous",
    codingServiceCta: "Indicateurs personnalisés et bots de trading",
    contactUsNow: "Contactez-Nous Maintenant!",
    
    // Support Ticket
    needHelp: "Besoin d'Aide?",
    supportDescription: "Soumettez un ticket de support et notre équipe vous répondra dès que possible.",
    ticketSubmitted: "Ticket Soumis!",
    ticketSubmittedDesc: "Nous avons reçu votre message et répondrons à votre email sous peu.",
    yourName: "Votre Nom",
    enterYourName: "Entrez votre nom",
    yourEmail: "Votre Email",
    enterYourEmail: "Entrez votre email",
    subject: "Sujet",
    enterSubject: "De quoi s'agit-il?",
    message: "Message",
    enterMessage: "Décrivez votre problème ou question...",
    submitting: "Envoi en cours...",
    submitTicket: "Soumettre le Ticket",
    
    // Disclaimer
    disclaimer: "Avertissement",
    disclaimerText: "Nous ne fournissons pas de conseils financiers, d'investissement ou de trading, et nous ne gérons ni n'investissons d'actifs en votre nom. Tout le contenu et les outils fournis sont uniquement à des fins éducatives, destinés à vous aider à mieux comprendre les marchés et à les aborder avec un jugement éclairé.",
    checkSpamFolder: "Veuillez vérifier votre dossier spam ou courrier indésirable si vous ne voyez pas notre email.",
    
    joinTraders: "Rejoignez des milliers de traders qui prennent de meilleures décisions",
    createFreeAccount: "Commencer",
    topProfitableAssets: "Actifs les Plus Rentables",
    basedOnUserReports: "Basé sur les rapports des utilisateurs",
    noTradeDataYet: "Pas encore de données de trading",
    mostStableAssets: "Actifs les Plus Stables",
    stableAssetsDesc: "30 dernières min • Mèche basse • Signaux clairs",
    analyzingAssets: "Analyse des actifs...",
    stability: "Stabilité",
    clearSignals: "signaux clairs",
    allIndicatorsMacdStochRsi: "Tous les Indicateurs (MACD + STOCH + RSI)",
    macdOnly: "MACD Seulement",
    stochasticOnly: "Stochastique Seulement",
    rsiPeriod7Only: "RSI (Période 7) Seulement",
    usingAllIndicators: "🔥 Utilisant les 3 indicateurs - Signal CHAUD quand tous s'accordent!",
    macdDesc: "📊 MACD: L'histogramme croise au-dessus/en-dessous de la ligne 0",
    stochDesc: "📈 Stochastique: La ligne K entre/sort des zones de surachat/survente",
    rsiDesc: "⚡ RSI 7: Croise au-dessus/en-dessous du niveau 50 (style Pocket Option)",
    smartExpiryRecommendation: "Recommandation d'Expiration Intelligente",
    aiSuggestsOptimal: "L'IA suggère la durée optimale du trade",
    reportBeforeNew: "📊 Rapportez le résultat de votre trade avant de générer un nouveau signal",
    generateSignalFor: "🎯 Générer Signal pour",
    analyzingMarketSecs: "Analyse du Marché...",
    generatingSignal: "Génération du Signal...",
    loginToGenerateSignal: "🔒 Connectez-vous pour Générer un Signal",
    signUpToAccess: "Inscrivez-vous et obtenez l'approbation pour accéder à la génération de signaux",
    hotSignalAll3: "🔥🔥🔥 SIGNAL CHAUD - LES 3 INDICATEURS S'ACCORDENT! 🔥🔥🔥",
    executeNow: "⚡ EXÉCUTER MAINTENANT",
    medium: "MOYEN",
    suggested: "SUGGÉRÉ",
    confidence: "confiance",
    momentumScore: "Score de Momentum",
    noTradesRecorded: "Aucun trade enregistré pour cette période",
    tradingDisclaimer1: "Les signaux de trading sont à des fins éducatives uniquement.",
    tradingDisclaimer2: "Tradez toujours de manière responsable.",
    referAndEarn: "Parrainer et Gagner",
    get7FreeDays: "Obtenez 7 jours gratuits pour chaque ami qui s'abonne!",
    loadingReferralInfo: "Chargement de vos informations de parrainage...",
    sessionExpiredInvalid: "Session expirée ou invalide",
    pleaseLogOutIn: "Veuillez vous déconnecter et vous reconnecter",
    retry: "Réessayer",
    unableLoadReferral: "Impossible de charger le code de parrainage",
    tokenMayChanged: "Votre token a peut-être changé. Veuillez vous déconnecter et vous reconnecter.",
    yourCode: "Votre Code",
    referrals: "Parrainages",
    bonusDays: "Jours Bonus",
    extension: "Extension",
    howItWorks: "Comment ça marche:",
    howItWorksStep1: "1. Partagez votre lien de parrainage avec vos amis",
    howItWorksStep2: "2. Quand ils s'inscrivent et s'abonnent, vous obtenez 7 jours gratuits",
    howItWorksStep3: "3. Gagnez jusqu'à 30 jours d'accès gratuit!",
    shareOnWhatsApp: "Partager sur WhatsApp",
    shareOnTelegram: "Partager sur Telegram",
    joinMeOnTrading: "Rejoignez-moi sur Trading Signal Generator et obtenez des signaux premium! Utilisez mon lien:",
    paymentProofAwait: "Preuve de paiement soumise! En attente de vérification admin.",
    youveBeenReferred: "Vous avez été parrainé! Inscrivez-vous maintenant pour commencer.",
    signUpNow: "S'inscrire Maintenant",
    foundPairs: "Trouvées",
    pairs: "paires",
    noPairsFound: "Aucune paire trouvée pour",
    trySearchTerms: "Essayez: EUR, USD, BTC, GOLD",
    forex: "FOREX",
    crypto: "CRYPTO",
    commodities: "MATIÈRES PREMIÈRES",
    stocks: "ACTIONS"
  },
  
  ht: {
    // Header
    signalGenerator: "Jeneratè Siyal",
    tradingPortal: "Pòtal Siyal Kòmès",
    admin: "Admin",
    loginSignup: "Konekte / Enskri",
    logout: "Dekonekte",
    welcome: "Byenveni",
    
    // Navigation & Common
    home: "Akèy",
    dashboard: "Tablo",
    settings: "Paramèt",
    profile: "Pwofil",
    back: "Retounen",
    next: "Pwochen",
    save: "Anrejistre",
    cancel: "Anile",
    close: "Fèmen",
    confirm: "Konfime",
    delete: "Efase",
    edit: "Modifye",
    search: "Chèche",
    loading: "Ap chaje...",
    error: "Erè",
    success: "Siksè",
    
    // Guest Portal
    manualSignalGenerator: "Jeneratè Siyal Manyèl",
    selectPairDescription: "Chwazi yon pè kòmès epi jenere siyal ki baze sou endikatè MACD, Stochastik & RSI",
    selectTradingPair: "Chwazi Pè Kòmès",
    availablePairs: "Pè ki Disponib",
    yourSignals: "Siyal Ou yo",
    generateSignal: "Jenere Siyal",
    loginToGenerate: "Konekte pou Jenere Siyal",
    signUpPrompt: "Enskri epi jwenn apwobasyon pou aksede jenerasyon siyal",
    generating: "Ap jenere...",
    searchPairs: "Chèche pè...",
    
    // Pro Tip
    proTip: "Konsèy Pro",
    proTipMessage: "Toujou jenere siyal 18 segonn anvan pwochen chandèl pou pi bon rezilta",
    
    // Analyzing
    analyzingMarket: "Ap Analize Done Mache a...",
    analyzingMarketShort: "Ap Analize Mache...",
    scanningBestEntry: "Ap chèche pi bon pwen antre...",
    macdAnalysis: "Analiz MACD",
    rsiAnalysis: "Analiz RSI",
    stochasticAnalysis: "Stochastik",
    
    // Signal Results
    signalFound: "Siyal Jwenn!",
    noSignalFound: "Pa Gen Siyal Disponib",
    waitingForSignal: "Ap tann kondisyon siyal yo aliyen",
    direction: "Direksyon",
    expiry: "Ekspirasyon",
    payout: "Peman",
    accuracy: "Presizyon",
    signalStrength: "Fòs Siyal",
    hotSignal: "SIYAL CHO",
    strongSignal: "SIYAL FÒ",
    allIndicatorsAgree: "TOU 3 ENDIKATÈ YO DAKÒ!",
    twoIndicatorsAgree: "2 nan 3 endikatè dakò",
    buy: "ACHTE",
    sell: "VANN",
    call: "CALL",
    put: "PUT",
    recommendedExpiry: "Ekspirasyon Rekòmande",
    
    // Trade Reporting
    reportTradeResult: "Rapòte Rezilta Trade Ou",
    reportPrompt: "Èske dènye trade ou a te genyen oswa pèdi? Rapòte pou jenere nouvo siyal",
    win: "GENYEN",
    loss: "PÈDI",
    skip: "PASE",
    skipIfNotTraded: "Pase si ou pa t fè trade siyal sa a",
    lastSignal: "Dènye siyal",
    on: "sou",
    
    // Profitability Stats
    tradingStats: "Estatistik Trade Ou yo",
    trades: "Trade yo",
    wins: "Genyen yo",
    losses: "Pèdi yo",
    winRate: "To Siksè",
    last24h: "Dènye 24h",
    yesterday: "Yè",
    thisWeek: "Semèn sa a",
    allTime: "Tout Tan",
    profitability: "Rentabilite",
    
    // Top Assets
    topAssets: "Pi Bon Aktif yo",
    topProfitable: "Pi Rentab",
    mostStable: "Pi Estab",
    viewAll: "Wè Tout",
    
    // Indicators
    selectIndicators: "Chwazi Endikatè yo",
    allIndicators: "Tout Endikatè yo",
    indicators: "Endikatè yo",
    
    // Auth Modal
    login: "Konekte",
    createAccount: "Kreye Kont",
    emailAddress: "Adrès Imèl",
    nameOptional: "Non (opsyonèl)",
    enterEmail: "Antre imèl ou pou aksede siyal yo",
    signUpForSignals: "Enskri pou siyal kòmès",
    dontHaveAccount: "Ou pa gen kont?",
    alreadyHaveAccount: "Ou gen yon kont deja?",
    signUp: "Enskri",
    continue: "Kontinye",
    pleaseWait: "Tanpri tann...",
    getStarted: "Kòmanse",
    
    // Profile Completion
    completeProfile: "Konplete Pwofil Ou",
    selectCountry: "Chwazi peyi ou",
    completeProfileButton: "Konplete Pwofil",
    
    // Plan Selection
    choosePlan: "Chwazi Plan Ou",
    freeTrial: "Plan Esansyèl",
    free: "DEPI $20",
    trialFeature1: "5 jou aksè konplè",
    trialFeature2: "Tout pè kòmès yo",
    trialFeature3: "Siyal an tan reyèl",
    trialExpires: "Esansyèl: $20/5 jou • Premyòm: $59.99/mwa",
    startFreeTrial: "Kòmanse Kounye a",
    monthlySubscription: "Abònman Premyòm",
    subscriptionFeature1: "30 jou aksè konplè",
    subscriptionFeature2: "Tout pè kòmès yo",
    subscriptionFeature3: "Siyal an tan reyèl",
    subscriptionFeature4: "Sipò priyorite",
    subscribeNow: "Abònman Kounye a",
    paymentVia: "Peman atravè USDT (BNB Smart Chain)",
    
    // Referral System
    haveReferralCode: "Ou gen yon kòd referans?",
    enterCode: "Antre kòd",
    discountApplied: "rediksyon aplike!",
    from: "de",
    invalidCode: "Kòd envalid",
    referralProgram: "Pwogram Referans",
    yourReferralCode: "Kòd Referans Ou",
    yourReferralLink: "Lyen Referans Ou",
    copyLink: "Kopye Lyen",
    copied: "Kopye!",
    shareWithFriends: "Pataje ak zanmi epi genyen rekonpans!",
    referralBonus: "Bonis Referans",
    referredUsers: "Itilizatè Refere",
    
    // Payment Modal
    trialExpired: "Esè Ekspire",
    trialEndedMessage: "Esè gratis ou fini. Abònman pou kontinye.",
    getUnlimitedAccess: "Jwenn aksè san limit nan siyal kòmès",
    oneTimePayment: "Peman yon sèl fwa (Pa rekiran)",
    scanQRCode: "Eskane kòd QR pou peye ak",
    network: "Rezo",
    paymentInstructions: "Enstriksyon Peman",
    instruction1: "Ouvri bous kriptyo ou (Trust Wallet, MetaMask, elatriye)",
    instruction2: "Chwazi USDT sou BNB Smart Chain",
    instruction3: "Eskane kòd QR ki anwo a",
    instruction4: "Voye egzakteman",
    instruction5: "Klike \"Mwen Fè Peman\" anba a",
    warning: "Sèlman voye USDT sou BNB Smart Chain (BEP-20). Voye lòt token oswa itilize move rezo pral lakòz pèt lajan.",
    iveMadePayment: "Mwen Fè Peman",
    maybeLater: "Petèt Pita",
    paymentFor: "Peman pou",
    paymentRequired: "Peman obligatwa pou kontinye itilize aplikasyon an",
    
    // Payment Proof Upload
    uploadPaymentProof: "Telechaje Prèv Peman",
    yourName: "Non Ou",
    enterYourName: "Antre non konplè ou",
    uploadScreenshot: "Telechaje Screenshot",
    selectScreenshot: "Chwazi screenshot peman",
    maxFileSize: "Gwosè maksimòm: 5MB (PNG, JPG, JPEG)",
    submitPaymentProof: "Soumèt Prèv Peman",
    uploading: "Ap telechaje...",
    paymentProofSubmitted: "Prèv peman soumèt! Admin ap verifye byento.",
    backToPayment: "Retounen nan Peman",
    
    // Status Messages
    pendingVerification: "Verifikasyon Imèl an Atant",
    pendingApproval: "Apwobasyon an Atant",
    accountBlocked: "Kont Bloke",
    accountRejected: "Kont Pa Apwouve",
    accountApproved: "Kont Apwouve",
    trialActive: "Esè Aktif",
    subscriptionActive: "Abònman Aktif",
    
    // Promotion
    specialOffer: "Òf Espesyal!",
    copyCode: "Kòd",
    discount: "Rediksyon",
    
    // Education TV
    educationTV: "TV Edikasyon",
    watchNow: "Gade Kounye a",
    newContent: "Nouvo Kontni",
    noVideosAvailable: "Pa gen videyo disponib",
    
    // Messenger
    messages: "Mesaj yo",
    newMessage: "Nouvo Mesaj",
    typeMessage: "Tape yon mesaj...",
    send: "Voye",
    noMessages: "Pa gen mesaj ankò",
    unreadMessages: "mesaj pa li",
    
    // Footer
    disclaimer: "Siyal kòmès yo se pou objektif edikasyon sèlman. Toujou fè kòmès ak responsablite.",
    
    // Language
    language: "Lang",
    english: "Anglè",
    french: "Fransè",
    haitianCreole: "Kreyòl Ayisyen",
    spanish: "Panyòl",
    
    // Visitor Landing Page
    welcomeTitle: "Byenveni nan BonBot",
    welcomeSubtitle: "Patnè Trading Entèlijan Ou",
    heroDescription: "Jwenn siyal kòmès egzak ki alimante pa analiz teknik avanse",
    feature1Title: "Siyal an Tan Reyèl",
    feature1Desc: "Jwenn siyal imedyatman ki baze sou endikatè MACD, RSI ak Stochastik",
    feature2Title: "Gwo Presizyon",
    feature2Desc: "Siyal nou yo gen yon istwa pwouve ak gwo pousantaj siksè",
    feature3Title: "Fasil pou Itilize",
    feature3Desc: "Entèfas senp ki fèt pou komèsan tout nivo",
    startTradingNow: "Kòmanse Trading Kounye a",
    joinThousands: "Rejwenn dè milye de komèsan ki gen siksè",
    
    // Time
    seconds: "segonn",
    minutes: "minit",
    hours: "èdtan",
    days: "jou",
    ago: "pase",
    justNow: "Kounye a menm",
    
    // Misc
    online: "Sou entènèt",
    offline: "Pa sou entènèt",
    active: "Aktif",
    inactive: "Pa aktif",
    approved: "Apwouve",
    pending: "An atant",
    rejected: "Rejte",
    blocked: "Bloke",
    trial: "Esè",
    paid: "Peye",
    
    // Chat Bot & Messenger
    supportChat: "Chat Sipò",
    chatWithAdmin: "Chat ak Admin",
    chatWithSupport: "Chat ak Sipò",
    noMessagesYet: "Pa gen mesaj ankò",
    startConversation: "Voye yon mesaj pou kòmanse konvèsasyon",
    loadingMessages: "Ap chaje mesaj yo...",
    messageSent: "Mesaj voye!",
    newMessageFromAdmin: "Nouvo mesaj nan Admin!",
    newMessageFromUser: "Nouvo mesaj nan itilizatè!",
    
    // Chat Bot Greeting
    botGreeting: "👋 Bonjou! Byenveni nan Sipò Pocket Option Pro!",
    botHowCanIHelp: "Kijan mwen ka ede ou jodi a?",
    paymentHelp: "💳 Èd ak Peman",
    referralHelp: "🎁 Pwogram Referans",
    talkToSupport: "👤 Pale ak Sipò",
    
    // Payment Bot Response
    paymentBotTitle: "💳 Enfòmasyon Peman",
    paymentBotIntro: "Men kijan sistèm peman nou fonksyone:",
    paymentBotStep1: "1. Abònman mansyèl la koute $59.99 USD",
    paymentBotStep2: "2. Nou aksepte sèlman USDT sou rezo BNB Smart Chain (BEP-20)",
    paymentBotStep3: "3. Eskane kòd QR la oswa kopye adrès bous la",
    paymentBotStep4: "4. Apre peman, klike sou 'Mwen Te Fè Peman' epi telechaje prèv",
    paymentBotStep5: "5. Admin ap verifye epi aktive kont ou nan 24 èdtan",
    paymentBotWalletLabel: "💰 Adrès Bous (BEP-20):",
    paymentBotWarning: "⚠️ Voye sèlman USDT sou rezo BNB Smart Chain!",
    
    // Referral Bot Response
    referralBotTitle: "🎁 Pwogram Referans",
    referralBotIntro: "Genyen jou abònman gratis lè ou refere zanmi!",
    referralBotStep1: "1. Pataje lyen referans inik ou ak zanmi",
    referralBotStep2: "2. Lè yo enskri epi abòne, ou jwenn 7 jou GRATIS",
    referralBotStep3: "3. Ou ka genyen jiska 30 jou aksè gratis!",
    referralBotStep4: "4. Tcheke estatistik ou nan seksyon Refere epi Genyen",
    referralBotNote: "💡 Plis zanmi ou refere, plis jou gratis ou genyen!",
    
    // Talk to Support Form
    talkToSupportTitle: "👤 Pale ak Sipò",
    enterYourNameChat: "Antre non ou",
    describeIssue: "Dekri pwoblèm oswa kesyon ou",
    submitToSupport: "Voye bay Sipò",
    supportRequestSent: "✅ Mesaj ou te voye bay sipò!",
    supportWillRespond: "Ekip nou ap reponn byento.",
    
    // Read Receipts
    seen: "Wè",
    delivered: "Livre",
    
    // Chat Controls
    endChat: "Fini Chat",
    chatEnded: "Chat Fini",
    chatEndedByAdmin: "Chat sa a te fini pa admin poutèt inaktivite.",
    chatEndedByUser: "Ou te fini chat sa a.",
    noResponseTimeout: "Pa gen repons pou 20 minit",
    startNewConversation: "Kòmanse Nouvo Konvèsasyon",
    
    // Image Upload
    attachImage: "Atache Imaj",
    imageUploaded: "Imaj telechaje",
    imageTooLarge: "Imaj dwe pi piti pase 5MB",
    invalidImageType: "Sèlman imaj PNG, JPG, JPEG aksepte",
    
    // Additional Guest Portal Keys
    smartTradingSignals: "Yon Sistèm Kòmès Entèlijan Kote Edikasyon Genyen",
    makeInformedDecisions: "Pran desizyon enfòme ak analiz mache ki alimante pa IA",
    getStartedSignIn: "Kòmanse - Konekte",
    missQuote: "Ou manke 100% ti nan ou pa tire",
    wayneGretzky: "Wayne Gretzky",
    aiPoweredSignals: "Siyal IA",
    aiPoweredSignalsDesc: "Analiz MACD, Stochastik ak RSI konbine pou prediksyon egzak",
    trackYourSuccess: "Swiv Siksè Ou",
    trackYourSuccessDesc: "Siveyans to siksè ak rentabilite ak estatistik detaye",
    topPerformersTitle: "Pi Bon Pèfòman",
    topPerformersDesc: "Wè aktif ki pi rentab ak estab an tan reyèl",
    topPerformers: "Top Performers",
    live: "DIRÈK",
    signalAccuracy: "Presizyon Siyal",
    tradingPairs: "Pè Kòmès",
    otcMarkets: "Mache OTC",
    systemAvailability: "Disponibilite Sistèm",
    startingFrom: "Depi",
    freeTrialAccess: "Plan Abònman",
    
    // TradingView Indicator
    tradingViewIndicator: "Endikatè Entèlijan TradingView",
    tradingViewIndicatorDesc: "Siyal nivo pwofesyonèl pou mache Forex ak Futures",
    forexMarkets: "Mache Forex",
    futuresMarkets: "Mache Futures",
    smartSignals: "Siyal Entèlijan",
    
    // Coding Service
    codingServiceTitle: "Di Nou Estrateji Ou e N Ap Pwograme Li Pou Ou",
    codingServiceCta: "Endikatè pèsonalize ak bòt kòmès",
    contactUsNow: "Kontakte Nou Kounye a!",
    
    // Support Ticket
    needHelp: "Bezwen Èd?",
    supportDescription: "Soumèt yon tikè sipò e ekip nou ap reponn ou pi vit posib.",
    ticketSubmitted: "Tikè Soumèt!",
    ticketSubmittedDesc: "Nou resevwa mesaj ou e n ap reponn nan imel ou talè.",
    yourName: "Non Ou",
    enterYourName: "Antre non ou",
    yourEmail: "Imel Ou",
    enterYourEmail: "Antre imel ou",
    subject: "Sijè",
    enterSubject: "Sa li ye?",
    message: "Mesaj",
    enterMessage: "Dekri pwoblèm ou oswa kesyon ou...",
    submitting: "Ap soumèt...",
    submitTicket: "Soumèt Tikè",
    
    // Disclaimer
    disclaimer: "Avètisman",
    disclaimerText: "Nou pa bay konsèy finansye, envestisman oswa kòmès, e nou pa jere oswa envesti byen pou ou. Tout kontni ak zouti yo bay se pou bi edikasyon sèlman, pou ede ou pi byen konprann mache yo e abòde yo ak jijman enfòme.",
    checkSpamFolder: "Tanpri tcheke dosye spam oswa poubèl ou si ou pa wè imel nou an.",
    
    joinTraders: "Rejwenn dè milye de komèsan ki pran pi bon desizyon",
    createFreeAccount: "Kòmanse",
    topProfitableAssets: "Aktif ki Pi Rentab",
    basedOnUserReports: "Baze sou rapò itilizatè yo",
    noTradeDataYet: "Pa gen done kòmès ankò",
    mostStableAssets: "Aktif ki Pi Estab",
    stableAssetsDesc: "Dènye 30 min • Mèch ba • Siyal klè",
    analyzingAssets: "Ap analize aktif yo...",
    stability: "Stabilite",
    clearSignals: "siyal klè",
    allIndicatorsMacdStochRsi: "Tout Endikatè (MACD + STOCH + RSI)",
    macdOnly: "MACD Sèlman",
    stochasticOnly: "Stochastik Sèlman",
    rsiPeriod7Only: "RSI (Peryòd 7) Sèlman",
    usingAllIndicators: "🔥 Itilize tout 3 endikatè - Siyal CHO lè tout dakò!",
    macdDesc: "📊 MACD: Istogram travèse anwo/anba liy 0",
    stochDesc: "📈 Stochastik: Liy K antre/soti nan zòn sipèachte/sipèvann",
    rsiDesc: "⚡ RSI 7: Travèse anwo/anba nivo 50 (style Pocket Option)",
    smartExpiryRecommendation: "Rekòmandasyon Ekspirasyon Entèlijan",
    aiSuggestsOptimal: "IA sijere dire kòmès optimal",
    reportBeforeNew: "📊 Rapòte rezilta trade ou anvan jenere yon nouvo siyal",
    generateSignalFor: "🎯 Jenere Siyal pou",
    analyzingMarketSecs: "Ap Analize Mache...",
    generatingSignal: "Ap Jenere Siyal...",
    loginToGenerateSignal: "🔒 Konekte pou Jenere Siyal",
    signUpToAccess: "Enskri epi jwenn apwobasyon pou aksede jenerasyon siyal",
    hotSignalAll3: "🔥🔥🔥 SIYAL CHO - TOU 3 ENDIKATÈ DAKÒ! 🔥🔥🔥",
    executeNow: "⚡ EGZEKITE KOUNYE A",
    medium: "MWAYEN",
    suggested: "SIJERE",
    confidence: "konfyans",
    momentumScore: "Nòt Momanntoum",
    noTradesRecorded: "Pa gen trade anrejistre pou peryòd sa a",
    tradingDisclaimer1: "Siyal kòmès yo se pou objektif edikasyon sèlman.",
    tradingDisclaimer2: "Toujou fè kòmès ak responsablite.",
    referAndEarn: "Refere epi Genyen",
    get7FreeDays: "Jwenn 7 jou gratis pou chak zanmi ki abòne!",
    loadingReferralInfo: "Ap chaje enfòmasyon referans ou...",
    sessionExpiredInvalid: "Sesyon ekspire oswa envalid",
    pleaseLogOutIn: "Tanpri dekonekte epi konekte ankò",
    retry: "Eseye Ankò",
    unableLoadReferral: "Pa kapab chaje kòd referans",
    tokenMayChanged: "Token ou ka chanje. Tanpri dekonekte epi konekte ankò.",
    yourCode: "Kòd Ou",
    referrals: "Referans",
    bonusDays: "Jou Bonis",
    extension: "Ekstansyon",
    howItWorks: "Kijan li fonksyone:",
    howItWorksStep1: "1. Pataje lyen referans ou ak zanmi",
    howItWorksStep2: "2. Lè yo enskri epi abòne, ou jwenn 7 jou gratis",
    howItWorksStep3: "3. Genyen jiska 30 jou aksè gratis!",
    shareOnWhatsApp: "Pataje sou WhatsApp",
    shareOnTelegram: "Pataje sou Telegram",
    joinMeOnTrading: "Rejwenn mwen sou Trading Signal Generator epi jwenn siyal premium! Itilize lyen mwen:",
    paymentProofAwait: "Prèv peman soumèt! Ap tann verifikasyon admin.",
    youveBeenReferred: "Yo refere ou! Enskri kounye a pou kòmanse.",
    signUpNow: "Enskri Kounye a",
    foundPairs: "Jwenn",
    pairs: "pè",
    noPairsFound: "Pa jwenn pè pou",
    trySearchTerms: "Eseye: EUR, USD, BTC, GOLD",
    forex: "FOREX",
    crypto: "KRIPTO",
    commodities: "MACHANDIZ",
    stocks: "AKSYON"
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.en[key] || key;
};

export const useTranslation = (lang) => {
  return (key) => getTranslation(lang, key);
};

export default translations;
